import { AType } from "@silversea-ssc/functional-support"
import { GenericErrorResponse } from "../generic-error-response"
import { PricesErrorCode } from "./error-code"
import { PricesRequestV2 } from "./request"

export const PricesErrorResponseV2 = GenericErrorResponse(PricesRequestV2, PricesErrorCode, "PricesErrorResponseV2")
export type PricesErrorResponseV2 = AType<typeof PricesErrorResponseV2>
